import React from 'react';
import { Navigate, Outlet, useMatches } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { PageHeader } from '@/components/layouts/PageHeader';
import { useAdminModeAccess } from '@/hooks/useAdminModeAccess';
import { paths } from '@/app/paths';

/**
 * Element for the /admin route. Sends users without admin access home and renders the
 * header once for all admin pages (AppLayout puts /admin in admin mode). The header comes
 * from the deepest matched route's handle: { title, icon }.
 */
export const AdminLayout = () => {
	const { canAccessAdminMode, isAdminModeAccessLoading } = useAdminModeAccess();
	const matches = useMatches();

	if (!isAdminModeAccessLoading && !canAccessAdminMode) {
		return <Navigate to={paths.home} replace />;
	}

	const header = [...matches].reverse().find((match) => match.handle)?.handle;

	return isAdminModeAccessLoading ? (
		<Box display='flex' justifyContent='center' pt='4em'>
			<CircularProgress />
		</Box>
	) : (
		<>
			{header && <PageHeader title={header.title} icon={header.icon} />}
			<Box sx={{ px: 3, pb: 3 }}>
				<Outlet />
			</Box>
		</>
	);
};
